import { apis } from '@doltech/core/lib/api/api.config';
import { getUserAnonymousId } from '@doltech/core/lib/auth/constants';
import { useMutation } from 'react-query';
import { apiPublicUrls } from '@doltech/core/lib/api/api.public-urls';

export function useExerciseProgress() {
  return useMutation((data: any) =>
    apis.publicOnlineTestV2.post(apiPublicUrls.onlineTestV2.EXERCISES_PROGRESS, {
      ...data,
      sessionId: getUserAnonymousId(),
    })
  );
}
